import { render } from "./ReportTable.vue?vue&type=template&id=b992d914&scoped=true"
import script from "./ReportTable.vue?vue&type=script&lang=js"
export * from "./ReportTable.vue?vue&type=script&lang=js"

import "./ReportTable.vue?vue&type=style&index=0&id=b992d914&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b992d914"]])

export default __exports__